import { useQuery } from "@tanstack/react-query";

import { useGetCurrentUser } from "@/hooks/queries/useGetCurrentUser";
import { JOB_PAUSE_REQUEST_APPROVER_EMAIL } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, PendingPauseRequest } from "@/types";

export const PENDING_PAUSE_REQUESTS_QUERY_KEY = ["pending-pause-requests"];

// Only the approver is shown pause requests, so nobody else polls for them.
// The endpoint isn't gated — this is the same FE-only pattern the pause
// allowlist uses.
export function useGetPendingPauseRequests() {
  const currentUser = useGetCurrentUser();
  const isApprover =
    currentUser?.email.toLowerCase() === JOB_PAUSE_REQUEST_APPROVER_EMAIL;

  return useQuery({
    enabled: isApprover,
    queryKey: PENDING_PAUSE_REQUESTS_QUERY_KEY,
    refetchInterval: 30_000, // refetch pending pause requests every 30s
    queryFn: async () => {
      const path = "job-pause-requests/pending";
      const res = await guacHttpClient.get<
        PendingPauseRequest[],
        HttpResponse<PendingPauseRequest[]>
      >(path);

      return res.data;
    },
  });
}
